import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-mostrar-ot',
  templateUrl: './mostrar-ot.component.html',
  styleUrls: ['./mostrar-ot.component.scss']
})
export class MostrarOtComponent implements OnInit {

  private _orden_trabajo;
  @Input('orden_trabajo') set orden_trabajo(value: any) {
    this._orden_trabajo = value;
  };
  get orden_trabajo() {
    return this._orden_trabajo;
  }

  constructor() { }

  ngOnInit() { }

  caracteristicasOrdenadas(caracteristicas) {
    return caracteristicas.sort((a, b) => {
      if (a.caracteristica && typeof a.caracteristica.CaracProdImprOrden != 'undefined') {
        if (a.caracteristica.CaracProdImprOrden > b.caracteristica.CaracProdImprOrden) {
          return 1;
        }
        if (a.caracteristica.CaracProdImprOrden < b.caracteristica.CaracProdImprOrden) {
          return -1;
        }
      } else {
        if (a.ordenImpresion > b.ordenImpresion) {
          return 1;
        }
        if (a.ordenImpresion < b.ordenImpresion) {
          return -1;
        }
      }
      return 0;
    });
  }
}
